/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum TimelineEntryType {
    TaskJob = '0',
    Mission = 1,
}
